import React from 'react'
import HomeBanner from './HomeBanner'
import { OurProducts } from './OurProducts'
import { Awards } from './Awards'
import Sustainability from './Sustainability'
import Clients from './Clients'
import Testimonials from './Testimonials'
import Product from './Product'
import 'bootstrap/dist/css/bootstrap.min.css';
import SteelProduct from './SteelProduct';
import FaqGetInTouch from '../FAQ/FaqGetInTouch'
import GetApp from './GetApp'

const Home = () => {
  return (
    <div>
      <HomeBanner/>
      <OurProducts/>
      <Product />
      {/* <SteelProduct/> */}
      <Sustainability />
      <Clients /> 
      <Testimonials /> 
      <FaqGetInTouch />
      <GetApp />
    </div>
  )
}
export default Home

// import React, { useState, useEffect } from 'react';
// import { Modal, Button } from 'react-bootstrap';
// import HomeBanner from './HomeBanner';
// import { OurProducts } from './OurProducts';
// import Sustainability from './Sustainability';
// import Clients from './Clients';
// import Testimonials from './Testimonials';
// import Product from './Product';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import FaqGetInTouch from '../FAQ/FaqGetInTouch';
// import GetApp from './GetApp';

// const Home = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     const popupShown = sessionStorage.getItem('popupShown');
//     if (!popupShown) {
//       setShowPopup(true);
//       sessionStorage.setItem('popupShown', 'true'); // Set flag only for the session
//     }
//   }, []);

//   const handleClose = () => {
//     setShowPopup(false);
//   };

//   return (
//     <div>
//       {/* Popup Modal */}
//       <Modal show={showPopup} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Welcome to SK Cemets</Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{
//           backgroundImage: "url('../../Assets/AKImages/newSliderFirst.png)",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           color: "white", // Adjust text color for readability
//           padding: "20px"
//         }}>
//           Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque euismod, nisi eu consectetur egestas, nisl nunc fermentum nunc, at tincidunt massa odio at libero.
//         </Modal.Body>
//         {/* <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>Close</Button>
//         </Modal.Footer> */}
//       </Modal>

//       {/* Main Content */}
//       <HomeBanner />
//       <OurProducts />
//       <Product />
//       <Sustainability />
//       <Clients />
//       <Testimonials />
//       <FaqGetInTouch />
//       <GetApp />
//     </div>
//   );
// };

// export default Home;

